module.exports = __webpack_public_path__ + "img/ninja.bcc96629.png";